export const sendContactMessage = async (formData) => {
  try {
    const response = await fetch('https://preferredmed.longliveik.com/api/send-contact-email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to send message');
    }

    return data;
  } catch (error) {
    throw new Error(error.message || 'Failed to send message. Please try again.');
  }
};